import { FeatureList } from "us.common/interfaces";
import { IOperation } from "../interface";
import { MENU_ORDER } from "us.common/constants";

/**
 * It returns true if the link is in the quickLinks array, otherwise it returns false.
 * @param quickLinks - Array<IOperation>
 * @param {IOperation} link - IOperation = {
 * @returns A boolean value.
 */
export const isQuickLink = (
  quickLinks: Array<IOperation>,
  link: IOperation
): boolean => {
  try {
    return quickLinks?.some(
      (item: IOperation) =>
        item.id === link.id ||
        item.name.toLowerCase().trim() === link.name.toLowerCase().trim()
    );
  } catch (error) {
    return false;
  }
};

/**
 * @
 */
export const reorderMenuItems = (features: FeatureList[]): FeatureList[] => {
  try {
    if (features && features.length > 0) {
      return features.sort((a, b) => {
        const orderA = MENU_ORDER[a.name] ?? 1000;
        const orderB = MENU_ORDER[b.name] ?? 1000;
        return orderA - orderB;
      });
    }
    return [];
  } catch (error) {
    return features;
  }
};
